import { METER_READS_ERROR_CODES } from 'config/app-config';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { selectAttemptsCount } from 'state/meter-reads/move-in-meter-read-slice';
import {
  MeterReadAgentHandOffError,
  MeterReadMaxAttemptsError,
  MeterReadTolleranceError
} from 'errors/MeterReadErrors';
import {
  setError,
  setSuccess,
  incrementAttempts
} from 'state/meter-reads/move-in-meter-read-slice';
import { MOVE_IN_METER_READS_MAX_ATTEMPTS } from 'config/app-config';

export const useMeterReadsVerificationError = () => {
  const dispatch = useDispatch();
  const attemptsCount = useSelector(selectAttemptsCount, shallowEqual);
  let hasReachedMaxAttempts = false;

  return (response) => {
    const { errors } = response;
    const toleranceError = errors?.some(
      (error) =>
        error.code === METER_READS_ERROR_CODES.MeterReadsToleranceException
    );
    const agentHandoffError = errors?.some(
      (error) =>
        error.code === METER_READS_ERROR_CODES.MeterReadsAgentHandoverException
    );
    hasReachedMaxAttempts =
      attemptsCount >= MOVE_IN_METER_READS_MAX_ATTEMPTS - 1;

    if (agentHandoffError) {
      const error = new MeterReadAgentHandOffError(agentHandoffError);
      const agentHandoffErrors = [error.toJson()];
      dispatch(setError(agentHandoffErrors));
      dispatch(setSuccess(response));

      return agentHandoffErrors;
    }

    if (hasReachedMaxAttempts) {
      const error = new MeterReadMaxAttemptsError();
      const maxAttemptsErrors = [error.toJson()];
      dispatch(setError(maxAttemptsErrors));
      dispatch(setSuccess(response));
      toleranceError && dispatch(incrementAttempts());

      return maxAttemptsErrors;
    }

    if (toleranceError) {
      const error = new MeterReadTolleranceError(toleranceError);
      const tolleranceErrors = [error.toJson()];
      dispatch(setError(tolleranceErrors));
      dispatch(setSuccess(response));
      dispatch(incrementAttempts());

      return tolleranceErrors;
    }

    return errors;
  };
};
